<!--
  Severity tag. Kept low-key on dark — the page chrome already signals
  attention via the status bar at the top. Tones match ui.md (err / warn /
  info); the word is always shown, so the colour is never the only signal.
-->
<script lang="ts">
	import { Badge } from '@navitech/ui';
	import type { Severity } from '../lib/types';

	const { severity }: { severity: Severity } = $props();
	const TONE: Record<Severity, 'err' | 'warn' | 'info'> = {
		high: 'err',
		medium: 'warn',
		low: 'info',
	};
</script>

<Badge tone={TONE[severity]}>{severity}</Badge>
